<template>
  <div class="questionnaire-exit-modal-backdrop">


  <div class="questionnaire-exit-modal">
    <div class="questionnaire-exit-modal__wrapper">


      <div class="questionnaire-exit-modal__icon">
        <svg width="126" height="126" viewBox="0 0 126 126" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="63" cy="63" r="58.5" fill="#F9F9F9" stroke="white" stroke-width="9" />
          <g clip-path="url(#clip0_1466_4)">
            <path
              d="M62.9998 97C44.2523 97 29 81.7476 29 63C29 44.2524 44.2523 29 62.9998 29C81.7477 29 97 44.2524 97 63C97 69.7314 95.0361 76.2392 91.3209 81.8197C90.7478 82.6794 89.5879 82.9103 88.7291 82.3399C87.8704 81.7677 87.6367 80.6078 88.2089 79.7481C91.5144 74.7826 93.262 68.9912 93.262 63C93.262 46.3135 79.6862 32.738 62.9998 32.738C46.3134 32.738 32.738 46.3135 32.738 63C32.738 79.6861 46.3134 93.262 62.9998 93.262C68.3882 93.262 73.6767 91.8292 78.2936 89.1187C79.1852 88.5949 80.3296 88.8933 80.8516 89.784C81.3745 90.6747 81.0761 91.8201 80.1863 92.3421C74.9954 95.3893 69.0526 97 62.9998 97ZM60.5282 79.7835C60.6642 80.1057 60.8504 80.3886 61.0867 80.6322C61.324 80.8759 61.606 81.0657 61.9364 81.2017C62.2658 81.3377 62.6163 81.4061 62.9895 81.4061C63.3618 81.4061 63.7123 81.3377 64.0426 81.2017C64.3721 81.0657 64.6586 80.8759 64.9023 80.6322C65.146 80.3886 65.3358 80.1057 65.4718 79.7835C65.6077 79.4614 65.6762 79.1064 65.6762 78.7194C65.6762 78.3471 65.6077 77.9957 65.4718 77.6663C65.3358 77.3368 65.146 77.0503 64.9023 76.8066C64.6586 76.5629 64.3721 76.3695 64.0426 76.2262C63.7123 76.0829 63.3618 76.0108 62.9895 76.0108C62.6163 76.0108 62.2658 76.0829 61.9364 76.2262C61.606 76.3695 61.324 76.5629 61.0867 76.8066C60.8504 77.0503 60.6642 77.3368 60.5282 77.6663C60.3923 77.9957 60.3238 78.3471 60.3238 78.7194C60.3238 79.1064 60.3923 79.4614 60.5282 79.7835ZM61.2483 44.5939V62.5773C61.2483 63.2225 61.2592 63.8531 61.2802 64.4691C61.3021 65.0851 61.3341 65.7048 61.3769 66.3281C61.4198 66.9514 61.4737 67.5893 61.5385 68.2409C61.6033 68.8934 61.6781 69.5925 61.7639 70.3372H64.3648C64.4506 69.5925 64.5263 68.8934 64.5902 68.2409C64.655 67.5893 64.7088 66.9514 64.7517 66.3281C64.7946 65.7048 64.8266 65.0851 64.8485 64.4691C64.8704 63.8531 64.8804 63.2225 64.8804 62.5773V44.5939H61.2483Z"
              fill="url(#paint0_linear_1466_4)" />
          </g>
          <defs>
            <linearGradient id="paint0_linear_1466_4" x1="32.4" y1="84.4116" x2="99.0391" y2="72.5317"
              gradientUnits="userSpaceOnUse">
              <stop stop-color="#007EF5" />
              <stop offset="1" stop-color="#222224" />
            </linearGradient>
            <clipPath id="clip0_1466_4">
              <rect width="68" height="68" fill="white" transform="translate(29 29)" />
            </clipPath>
          </defs>
        </svg>


      </div>

      <header class="questionnaire-exit-modal__header">
        <h1 class="questionnaire-exit-modal__title">
          Aby otrzymać dostęp do strony <b>kerpro.pl</b> uzupełnij ankietę.
        </h1>
      
      </header>
         <div class="questionnaire-exit-modal__buttons">
              
                <button @click.prevent="logOut"
                  class="questionnaire-exit-modal__button">Nie zakładam konta</button>
                    <button @click.prevent="exitModal"
                  class="questionnaire-exit-modal__button questionnaire-exit-modal__button--gradient">
                  <span>Wracam do mojej ankiety</span>
                </button>
              </div>

    </div>
  </div>
  </div>


</template>

<script lang="ts">

import { useRouter } from 'vue-router';


export default {
  name: 'QuestionnaireExitModal',
  components: {

   
    
  },
  props: {
   
 
  },

  setup(props, {emit}) {
    const router = useRouter();
    const logOut = async () =>{
      //   localStorage.removeItem('customer');
      // localStorage.removeItem('refreshToken');
      // localStorage.removeItem('accessToken');
      //  localStorage.removeItem('isFilledQuestionnaire');
      
      // // await modalController.dismiss();
      // await router.push({ path: '/auth/welcome', replace: true });
      window.location.href = typeof questionnaireData != 'undefined' ? questionnaireData.logOutUrl : '/';
    }
    const exitModal =  () =>{
      emit('exitModal');
    }

    return { exitModal,logOut}
  }
}

</script>



<style lang="scss" >
.questionnaire-exit-modal-backdrop{
  background: rgba(0,0,0,.5);
  position: fixed;
  z-index: 99999;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px;
}
.questionnaire-exit-modal-content{
  &::part(content){
    width: 90%;
    height: auto;;
    overflow: visible;
    border-radius: 20px;
  }
}


.questionnaire-exit-modal{
   max-width: 1000px;
   background-size: auto 100%;   
  background-position: left center;
  background-repeat: no-repeat;
  background-color: #f2f2f2;
  margin-left: auto;
  margin-right: auto;
  border-radius: 20px;
  position: relative;
  padding-top: 90px;
  padding-bottom: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  


  @media (max-width: 768px){
    background-image: none !important;
    height: auto;
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 40px;
  }

  &__wrapper{
    width: 100%;
  }

  &__icon{
    position: absolute;
    top: -54px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 50%;
 
  }
  &__buttons{
      display: flex;
      gap: 12px;
      flex-wrap: wrap;
      justify-content: center;
      margin-top: 20px;
      margin-bottom: 30px;

    
    }

    &__button{
      background: white;
      border: 1px solid #000;
      width: 285px;
      height: 36px;
      border-radius: 20px;
      color: #000;
      font-size: 14px;
      font-weight: 400;
      padding-left: 20px;
      padding-right: 20px;
      position: relative;
      cursor: pointer;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      &--blue{
        background: #0082FA;
        color: white;
        border-width: 0;

      }
      &--red{
        
        background: #FA0D67;
        color: white;
        border-width: 0;
      }
      &--gradinet{
          background: linear-gradient(79.89deg, #007EF5 7.04%, #222224 92.86%);
          span{
            position: absolute;
            width: calc(100% - 2px);
            height: calc(100% - 2px);
            border-radius: 20px;
            top: 1px;
            left: 1px;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            background: white;

          }
      }
    }
 
  &__title{
    font-size: 28px;
    font-weight: 400 !important;
    text-align: center;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 28px;
    color: #0082FA;

    @media(max-width: 768px){
      font-size: 22px;
    }
  }
  &__subtitle{
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    max-width: 385px;;
    margin-left: auto;
    margin-right: auto;
    line-height: 28px;

     @media (max-width: 768px){
      font-size: 16px;
     }

  }

  

}

</style>